const namespace = 'API';

export const SET_NAVIGATION = `${namespace}/SET_NAVIGATION`;
export const SET_READYACTION = `${namespace}/SET_READYACTION`;
export const SET_START_PROJECT_POP = `${namespace}/SET_START_PROJECT_POP`;
export const SET_RECRUIT_POP = `${namespace}/SET_RECRUIT_POP`;
export const SET_PDS_POP = `${namespace}/SET_PDS_POP`;
export const SET_AWARDS_POP = `${namespace}/SET_AWARDS_POP`;
export const SET_CULTURE_POP = `${namespace}/SET_CULTURE_POP`;
export const SET_PRIVACY_POLICY_POP = `${namespace}/SET_PRIVACY_POLICY_POP`;
export const GET_WEATHER_PENDING = `${namespace}/GET_WEATHER_PENDING`;
export const GET_WEATHER_SUCCESS = `${namespace}/GET_WEATHER_SUCCESS`;
export const GET_WEATHER_FAIL = `${namespace}/GET_WEATHER_FAIL`;
export const GET_ADRESS_PENDING = `${namespace}/GET_ADRESS_PENDING`;
export const GET_ADRESS_SUCCESS = `${namespace}/GET_ADRESS_SUCCESS`;
export const GET_ADRESS_FAIL = `${namespace}/GET_ADRESS_FAIL`;
export const SET_LNB_COPY = `${namespace}/SET_LNB_COPY`;
export const SET_INTRO = `${namespace}/SET_INTRO`;
export const SET_PDS_LNB = `${namespace}/SET_PDS_LNB`;
export const SET_PREV_TIT = `${namespace}/SET_PREV_TIT`;
export const SET_LOADING = `${namespace}/SET_LOADING`;
